import React, { ReactNode } from "react";
import { useClientStore } from "@/shared/gql/apollo-client";
import { ApolloProvider as NativeApolloProvider } from "@apollo/client";

type Props = {
  children: ReactNode;
};

export const ApolloProvider = ({ children }: Props) => {
  // Get the client from the Zustand store, this will cause a re-render when the client is reset
  const client = useClientStore((state) => state.client);

  return (
    <NativeApolloProvider client={client}>{children}</NativeApolloProvider>
  );
};
